import { render, staticRenderFns } from "./messages.vue?vue&type=template&id=32a0d9e6&scoped=true"
import script from "./messages.vue?vue&type=script&lang=js"
export * from "./messages.vue?vue&type=script&lang=js"
import style0 from "./messages.vue?vue&type=style&index=0&id=32a0d9e6&prod&scoped=true&lang=css"
import style1 from "./messages.vue?vue&type=style&index=1&id=32a0d9e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a0d9e6",
  null
  
)

export default component.exports